import { AxiosResponse } from "axios";
import { api } from "../api";
import {
  TiendaPaquete,
  CreateTiendaPaqueteDto,
  UpdateTiendaPaqueteDto,
} from "./tienda-paquete.types";

export const getTiendaPaquetes = async (
  schoolId?: number
): Promise<TiendaPaquete[]> => {
  try {
    const params = schoolId ? { school_id: schoolId } : undefined;
    const response: AxiosResponse<TiendaPaquete[]> = await api.get(
      "/tienda/admin/paquetes",
      { params }
    );
    return response.status === 200 ? response.data : [];
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getTiendaPaquete = async (
  id: number
): Promise<TiendaPaquete | null> => {
  try {
    const response: AxiosResponse<TiendaPaquete> = await api.get(
      `/tienda/admin/paquetes/${id}`
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const createTiendaPaquete = async (
  dto: CreateTiendaPaqueteDto
): Promise<TiendaPaquete | null> => {
  try {
    const response: AxiosResponse<TiendaPaquete> = await api.post(
      "/tienda/admin/paquetes",
      dto
    );
    return response.status === 200 || response.status === 201
      ? response.data
      : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const updateTiendaPaquete = async (
  id: number,
  dto: UpdateTiendaPaqueteDto
): Promise<TiendaPaquete | null> => {
  try {
    const response: AxiosResponse<TiendaPaquete> = await api.patch(
      `/tienda/admin/paquetes/${id}`,
      dto
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const deleteTiendaPaquete = async (id: number): Promise<boolean> => {
  try {
    const response = await api.delete(`/tienda/admin/paquetes/${id}`);
    return response.status === 200;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
